export default "__VITE_ASSET__QAYNIxBR__"